import axios from "axios";
import {
    TP_USERS_LIST,
    TP_USERS_LIST_FAILD,
    TP_USERS_LIST_LOADING,
    ROLE_LIST
} from "../type/type";

const PROXY = process.env.REACT_APP_API_URL + "api/";

// Get TP User List
export const getAllLeads = (queryObject) => async (dispatch) => {
    try {
        dispatch({ type: TP_USERS_LIST_LOADING });
        const res = await axios.get(PROXY + 'sub-admin/tp-users', { params: queryObject });
        dispatch({
            type: TP_USERS_LIST,
            payload: res.data.result,
        });
        return res;
    } catch (err) {
        dispatch({ type: TP_USERS_LIST_FAILD });
        return err
    }
};

export const createCombination = (subAdminData) => async (dispatch) => {
    return await axios.post(PROXY + "sub-admin/add", subAdminData);
};

export const getRolesList = (page, limit, search) => async (dispatch) => {
    const res = await axios.get(
        PROXY + "role?page=" + page + "&limit=" + limit + "&search=" + search
    );
    dispatch({
        type: ROLE_LIST,
        payload: res.data.result,
    });
    return res;
};

export const getCompanyList = () => async (dispatch) => {
    const res = await axios.get(`${PROXY}general/company`);
    return res;
};

export const editCombination = (id, subAdminData) => async (dispatch) => {
    const res = await axios.put(PROXY + 'sub-admin/' + id, subAdminData)
    return res
}

export const getSubAdminDetailsById = (id) => async (dispatch) => {
    const res = await axios.get(PROXY + "sub-admin/get/" + id);
    return res;
};